import React, { useEffect } from "react";
import { useHistory, withRouter } from "react-router-dom";

const TimeSeriesMonthlyComponent = (props) => {
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await localStorage.setItem("skygeni-user-page", "Growth Modeling");
      await localStorage.setItem(
        "skygeni-user-growthModelingPage",
        "Time Series projection of Closed Won (Monthly)"
      );
      await localStorage.removeItem("skygeni-user-repPage");
      await localStorage.setItem(
        "params",
        JSON.stringify(props.match.params.filters)
      );
      history.push("/");
      window.location.reload();
    })();
  }, []);

  return <div style={{ margin: "1rem auto" }}>Loading...</div>;
};
let routerAddedTimeSeriesMonthlyComponent = withRouter(
    TimeSeriesMonthlyComponent
);
export default routerAddedTimeSeriesMonthlyComponent;
